// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2ymZk","title":"Info_title__2Q2p5","links":"Info_links__Y38QY","link":"Info_link__1gV_6","logo":"Info_logo__32zXp"};